import { useRaysyncStore } from '@/store/raysync/raysync-store'
import { useEffect, useState } from 'react'
import { isDev } from 'project-config/utils/env'

export function useRaysyncDownload() {
  const { raysyncSoftInfo } = useRaysyncStore()
  const [centosUrl, setCentosUrl] = useState('')
  const [ubuntuUrl, setUbuntuUrl] = useState('')
  const [url, setUrl] = useState('')
  const isLinux = navigator.platform.indexOf('Linux') > -1
  const isMac = navigator.platform.includes('Mac')
  const DOWNLOAD_BASE_URL = isDev()
    ? 'https://task-pre.renderbus.com'
    : 'https://task.renderbus.com'

  useEffect(() => {
    if (!raysyncSoftInfo) return
    setCentosUrl(
      `${DOWNLOAD_BASE_URL}/download/${raysyncSoftInfo.find((n) => n.includes('rpm')) || ''}`,
    )
    setUbuntuUrl(
      `${DOWNLOAD_BASE_URL}/download/${raysyncSoftInfo.find((n) => n.includes('deb')) || ''}`,
    )
    const isMac = navigator.platform.includes('Mac')
    const suffix = isMac ? 'dmg' : 'exe'
    setUrl(
      `${DOWNLOAD_BASE_URL}/download/${
        raysyncSoftInfo.find((n: string) => n.includes(suffix)) || ''
      }`,
    )
  }, [raysyncSoftInfo])

  return {
    centosUrl,
    ubuntuUrl,
    url,
    isLinux,
    isMac,
  }
}
